var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(94.900513%, 94.900513%, 96.861267%)",
    fillOpacity: 1,
    d: "M 26 13 C 26 20.179688 20.179688 26 13 26 C 5.820312 26 0 20.179688 0 13 C 0 5.820312 5.820312 0 13 0 C 20.179688 0 26 5.820312 26 13 Z M 26 13 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(45.097351%, 45.097351%, 49.01886%)",
    fillOpacity: 1,
    d: "M 12 8 L 14 8 L 14 18 L 12 18 Z M 12 8 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(45.097351%, 45.097351%, 49.01886%)",
    fillOpacity: 1,
    d: "M 8 14 L 8 12 L 18 12 L 18 14 Z M 8 14 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.40ea1f8fa62d4f42930bef7069a09b08.svg";
export { ForwardRef as ReactComponent };